/*
 *
 * TravelSearchBar actions
 *
 */

import {
  CLEAR_CURRENT_SELECTION,
  CLEAR_RETURN_DATE,
  DAY_CLICKED,
  HIDE_API_CARDS_LIST,
  HOUR_CLICKED,
  LOAD_AUTOCOMPLETE_ERROR,
  LOAD_AUTOCOMPLETE_LOADING,
  LOAD_AUTOCOMPLETE_SUCCESS,
  LOAD_DISCOUNT_CARDS,
  LOAD_DISCOUNT_CARDS_ERROR,
  LOAD_DISCOUNT_CARDS_SUCCESS,
  LOAD_POPULAR,
  NAVIGATE,
  SET_CITY,
  SET_CURRENT_FIELD,
  SET_DATE,
  SUGGESTION_CLICKED,
  SWITCH_PLACES,
  UPDATE_DATE_FOCUS,
  UPDATE_FOCUS_AFTER_DELETE,
  UPDATE_PASSENGER_FOCUS,
  UPDATE_PLACE_QUERY,
} from './constants';

export function setCurrentFieldAction(newFocus) {
  return {
    type: SET_CURRENT_FIELD,
    newFocus,
  };
}

export function keyPressedAction(event) {
  return {
    type: NAVIGATE,
    event,
  };
}

export function getSuggestionsAction(direction, query, partnerId) {
  return {
    type: UPDATE_PLACE_QUERY,
    direction,
    query,
    partnerId,
  };
}

export function getPopularAction(direction) {
  return {
    type: LOAD_POPULAR,
    direction,
  };
}

export function loadAutocompleteSuccessAction(
  direction,
  suggestions,
  navigationMatch,
) {
  return {
    type: LOAD_AUTOCOMPLETE_SUCCESS,
    direction,
    suggestions,
    navigationMatch,
  };
}

export function loadAutocompleteErrorAction(error) {
  return {
    type: LOAD_AUTOCOMPLETE_ERROR,
    error,
  };
}

export function suggestionClickedAction(id) {
  return {
    type: SUGGESTION_CLICKED,
    id,
  };
}

export function dayClickedAction(departureDate, returnDate) {
  return {
    type: DAY_CLICKED,
    departureDate,
    returnDate,
  };
}

export function hourClickedAction(hour) {
  return {
    type: HOUR_CLICKED,
    hour,
  };
}

export function updateDateFocusAction(dateFocus) {
  return {
    type: UPDATE_DATE_FOCUS,
    dateFocus,
  };
}

export function clearReturnDateAction() {
  return {
    type: CLEAR_RETURN_DATE,
  };
}

export function updatePassengerFocusAction(id) {
  return {
    type: UPDATE_PASSENGER_FOCUS,
    id,
  };
}

export function updateFocusAfterDeleteAction(passengersLength, id) {
  return {
    type: UPDATE_FOCUS_AFTER_DELETE,
    passengersLength,
    id,
  };
}

export function switchPlacesAction() {
  return {
    type: SWITCH_PLACES,
  };
}

export function getDiscountCardsAction(passenger) {
  return {
    type: LOAD_DISCOUNT_CARDS,
    passenger,
  };
}

export function loadDicountCardsSuccessAction(cardsList) {
  return {
    type: LOAD_DISCOUNT_CARDS_SUCCESS,
    cardsList,
  };
}

export function loadDicountCardsErrorAction(error) {
  return {
    type: LOAD_DISCOUNT_CARDS_ERROR,
    error,
  };
}

export function hideApiCardsListAction() {
  return {
    type: HIDE_API_CARDS_LIST,
  };
}

export function loadAutocompleteLoadingAction(value) {
  return {
    type: LOAD_AUTOCOMPLETE_LOADING,
    value,
  };
}

export function setCityAction(cityName, cityId, direction) {
  return {
    type: SET_CITY,
    cityName,
    cityId,
    direction,
  };
}

export function setDateAction(date, direction) {
  return {
    type: SET_DATE,
    date,
    direction,
  };
}

export function clearCurrentSelectionAction() {
  return {
    type: CLEAR_CURRENT_SELECTION,
  };
}
